import { render } from "./MyDiseaseStatTable.vue?vue&type=template&id=c256e158&lang=html"
import script from "./MyDiseaseStatTable.vue?vue&type=script&lang=js"
export * from "./MyDiseaseStatTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__